import moment from "moment/moment";

export interface CrgMonthOption {
  value: string;
  label: string;
}

export function currentCrgMonth(): string {
  return moment().format("MM/YYYY");
}

/** Les treize derniers mois, du plus récent au plus ancien, au format « MM/YYYY ». */
export function buildCrgMonthOptions(): CrgMonthOption[] {
  const currentMonth = currentCrgMonth();
  return Array.from({ length: 13 }, (_, i) => {
    const monthMoment = moment().subtract(i, "months");
    const label = monthMoment.format("MMMM YYYY");
    const value = monthMoment.format("MM/YYYY");
    return {
      value,
      label:
        label.charAt(0).toUpperCase() +
        label.slice(1) +
        (value === currentMonth ? " (mois en cours)" : ""),
    };
  });
}
